export default __webpack_public_path__ + "static/media/cloud9ignite.9e0c4fa1.png";